import { render } from "./KnowledgeManagement.vue?vue&type=template&id=76a2b8c1"
import script from "./KnowledgeManagement.vue?vue&type=script&lang=js"
export * from "./KnowledgeManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__